import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Scenery_zn = () => {
  return (
    <React.Fragment>
      <SEO title="风景名胜 | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2-opt.jpg"
        title="风景名胜"
        content="For Participants"
        contentTwo="风景名胜"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
<div className="entry-content2">
          <div className="ch-lang-en">
            <Link className="btn btn-primary" to={process.env.PUBLIC_URL + "/scenery"}>English</Link>
          </div>
          <div className="space-50"></div>
          <h2>济州岛景点</h2>
          <p align="justify">
            <b>
            济州岛，韩国最大的火山岛屿，是一座将原始火山地貌与滨海休闲风情完美相融的海岛。作为知名的世界自然遗产度假胜地，它是韩国标志性的海岛旅游、康养与影视取景中心。济州岛以独有的火山地质景观、原生态海岛民俗，以及山野与海岸风光的奇妙交融而闻名，从巍峨休眠火山、幽深熔岩洞窟到澄澈蓝海黑岩海岸，应有尽有。
            <br></br> 
            济州岛坐拥多处享誉全球的自然瑰宝，包括岛内最高峰、拥有火山湖白鹿潭的汉拿山，以及海上火山喷发形成的世界自然遗产城山日出峰，登峰可尽览山海相融的壮阔景致。另一处必游之地是万丈窟熔岩洞窟，完整留存着百万年前火山活动留下的地质奇观，展现独一份的火山秘境。
            <br></br> 
            济州岛的风味美食是食客的好去处，汇集各类地道海岛特色佳肴，如济州黑猪肉、新鲜鲍鱼与清甜柑橘。无论你沿着临海偶来小路徒步观海，或是探访城邑民俗村、逛遍西归浦特色商圈，济州岛都能为所有游客带来治愈惬意、回味无穷的海岛体验。         
            </b>
          </p>

          <li>
            <a href="#Mount Hallasan">汉拿山</a>
          </li>
          <li>
            <a href="#Seongsan Ilchulbong">城山日出峰</a>
          </li>
          <li>
            <a href="#Udo Island">牛岛</a>
          </li>
          <li>
            <a href="#Manjanggul Cave">万丈窟‌</a>
          </li>
          <li>
            <a href="#Seopjikoji">涉地可支</a>
          </li>
          <li>
            <a href="#Yongduam Rock">龙头岩</a>
          </li>
          <li>
            <a href="#Daepo Jusangjeolli Cliff">柱状节理带</a>
          </li>
          <li>
            <a href="#Kimchi">韩国泡菜</a>
          </li>
          <li>
            <a href="#Samgyetang">韩国参鸡汤</a>
          </li>
          <li>
            <a href="#Korean BBQ">韩式烤肉</a>
          </li>
          <li>
            <a href="#Bibimbap">石锅拌饭</a>
          </li>

          <br />


          <hr></hr>
          <h4 id="Mount Hallasan">汉拿山</h4>
          <p align="justify">
            汉拿山是济州岛最高峰，海拔1950米，为韩国境内第一高峰，亦是一座休眠火山。山顶有神秘的白鹿潭火山湖，四季景色各异——春有烂漫山樱，夏有绿意盎然，秋有层林尽染，冬有银装素裹。汉拿山被联合国教科文组织列为世界自然遗产，是济州岛最具代表性的自然地标，登山徒步可饱览整座火山岛的壮阔风光。
          </p>
          <p>
            <img
              src="./images/scenery/hannashan-opt.jpg"
              alt="汉拿山"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Seongsan Ilchulbong">城山日出峰</h4>
          <p align="justify">
            城山日出峰位于济州岛东端，是一座由海底火山喷发形成的海上锥形火山口，高达182米，因清晨在此观赏壮丽日出而得名。其独特的碗状火山口与碧海蓝天相映成趣，被列入世界自然遗产。每逢佳节，这里还会举行传统海女表演，是体验济州自然与人文魅力的必到之地。
          </p>
          <p>
            <img
              src="./images/scenery/richufeng-opt.jpg"
              alt="城山日出峰"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Udo Island">牛岛</h4>
          <p align="justify">
            牛岛是位于济州岛东部的一座附岛，因轮廓形似卧牛而得名，被誉为珊瑚的宝库、海女的故乡。岛上有着碧蓝清澈的海滩、花生冰淇淋、海鲜面等地道美食，以及珊瑚沙滩、西滨白沙滩等自然景致。可乘轮渡登岛，骑行或乘环岛巴士漫游，尽享慢节奏的海岛度假风情。
          </p>
          <p>
            <img
              src="./images/scenery/niudao-opt.jpg"
              alt="牛岛"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Manjanggul Cave">万丈窟</h4>
          <p align="justify">
            万丈窟是济州岛最壮观、最具科研价值的熔岩洞窟之一，全长约13.4公里，其中部分区段对外开放。洞内保留着百万年前火山熔岩流淌形成的熔岩钟乳、熔岩柱与熔岩榻等奇观，是世界自然遗产的重要组成部分。恒温约11至21摄氏度的洞内环境，仿佛带你穿越回远古火山活动时期。
          </p>
          <p>
            <img
              src="./images/scenery/wanzhangku-opt.jpg"
              alt="万丈窟"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Seopjikoji">涉地可支</h4>
          <p align="justify">
            涉地可支位于济州岛东南端，是一处临海岬角，以蜿蜒的海岸步道、灯塔与春天的黄色油菜花海而闻名。这里曾是多部韩剧的取景地，站在这条向大海延伸的半岛上，可远眺城山日出峰与蔚蓝色海域，是摄影爱好者的天堂，也是感受济州浪漫海岸风光的绝佳去处。
          </p>
          <p>
            <img
              src="./images/scenery/shedikezhi-opt.jpg"
              alt="涉地可支"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Yongduam Rock">龙头岩</h4>
          <p align="justify">
            龙头岩位于济州岛西归浦市市区海滨，是一块历经自然风化、形似龙头的熔岩石像，高约10米，龙口朝向大海，传说富有灵性与护岛寓意。周边设有龙头岩公园，可近距离观赏海浪拍击岩石的壮观景象，也是欣赏济州西海岸日落的热门打卡点。
          </p>
          <p>
            <img
              src="./images/scenery/longtouyan-opt.jpg"
              alt="龙头岩"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Daepo Jusangjeolli Cliff">柱状节理带</h4>
          <p align="justify">
            大浦柱状节理带位于济州岛西归浦市，是约25万至14万年前火山熔岩遇海水骤冷收缩、自然碎裂而成的六角形柱状岩石群，犹如一根根巨大的石柱整齐排列于海岸边，蔚为壮观。这里是了解火山地质奥秘、拍摄海景的必访景点，展现了济州岛独特的火山海岸地貌。
          </p>
          <p>
            <img
              src="./images/scenery/zhuzhuangjielidai-opt.jpg"
              alt="柱状节理带"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Kimchi">韩国泡菜</h4>
          <p align="justify">
            韩国泡菜是朝鲜半岛最具代表性的传统发酵食品，以白菜、萝卜等蔬菜配以辣椒粉、大蒜、鱼露等调料腌制发酵而成，酸辣爽口、富含益生菌。在济州，可品尝到以当地特产柑橘、海产为特色的各类泡菜，是每一顿韩餐不可或缺的灵魂伴侣，也被联合国教科文组织列入人类非物质文化遗产。
          </p>
          <p>
            <img
              src="./images/scenery/hanguopaocai-opt.jpg"
              alt="韩国泡菜"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Samgyetang">韩国参鸡汤</h4>
          <p align="justify">
            参鸡汤是韩国传统的滋补名肴，以童子鸡肚子里塞入人参、糯米、大枣、大蒜等食材慢火炖制而成，汤清味醇、营养丰富。通常一鸡一汤一碗，连鸡带汤一并享用，有以热攻热的养生之说。在济州品尝一盅热腾腾的参鸡汤，温暖从胃暖到心，是感受韩式养生饮食文化的绝佳选择。
          </p>
          <p>
            <img
              src="./images/scenery/hanguocanjitaang-opt.jpg"
              alt="韩国参鸡汤"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Korean BBQ">韩式烤肉</h4>
          <p align="justify">
            韩式烤肉是韩国饮食文化的招牌之一，尤其在济州以黑猪肉烤肉最为著名——济州黑猪肉质紧实、脂肪分布均匀、风味独特。食客围坐炭火或铁板前，亲自烤制肉片，佐以生菜、包饭酱、蒜片和各色小菜，大口包进嘴里，是体验韩国豪爽食文化最接地气的方式。
          </p>
          <p>
            <img
              src="./images/scenery/hanshikaorou-opt.jpg"
              alt="韩式烤肉"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Bibimbap">石锅拌饭</h4>
          <p align="justify">
            石锅拌饭将米饭、各色时蔬、牛肉、鸡蛋与韩式辣酱置于滚烫石锅中，底部米饭形成诱人锅巴，搅拌后口感丰富、色彩缤纷。济州各城镇的餐厅与民俗村均能尝到正宗版本，一碗热腾腾的石锅拌饭，浓缩了韩餐五色五味的饮食哲学，简单却令人回味。
          </p>
          <p>
            <img
              src="./images/scenery/shiguobanfan-opt.jpg"
              alt="石锅拌饭"
              width="100%"
            />
          </p>
        </div>

      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Scenery_zn;
